module.exports = __webpack_public_path__ + "img/W7006-mod.402063d1.jpg";